import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { pluralizeWithCount } from "@common/helpers/string";
import { BatchGroupRow } from "../views/batchGroupsViewConfig";

export const BatchGroupCountCell = memo(
    ({ row }: { row: { original: BatchGroupRow } }) => (
        <ViewTableCell>
            {pluralizeWithCount("transaction", row.original.count)}
        </ViewTableCell>
    ),
);
BatchGroupCountCell.displayName = "BatchGroupCountCell";
